import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getQualitativeNotes({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_QUALITATIVE_NOTES_REQUEST')

        return axios
            .get(`/qualitative-notes/qualitative-notes${paginate}${query}`)
            .then(response => {
                commit('GET_QUALITATIVE_NOTES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_QUALITATIVE_NOTES_FAILURE')
                handleApiError(error, 'Pobranie listy uwag jakościowych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getQualitativeNote({ commit }, id) {
        return axios
            .get(`/qualitative-notes/qualitative-notes/${id}`)
            .then(response => {
                commit('GET_QUALITATIVE_NOTE_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do uwagi jakościowej ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createQualitativeNote({ commit }, payload) {
        return axios
            .post('/qualitative-notes/qualitative-notes', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Uwaga jakościowa została dodana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie uwagi jakościowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateQualitativeNotesReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/qualitative-notes/qualitative-notes?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteQualitativeNote({ commit }, id) {
        return axios
            .delete(`/qualitative-notes/qualitative-notes/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Uwaga jakościowa została usunięta.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie uwagi jakościowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCodes({ commit }) {
        return axios
            .get('/qualitative-notes/qualitative-notes/dicts/codes')
            .then(response => {
                commit('GET_CODES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie kodów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReportItemPlateOrders({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_REPORT_ITEM_PLATE_ORDERS_REQUEST')

        return axios
            .get(`/reports/report-item-plate-orders${paginate}${query}`)
            .then(response => {
                commit('GET_REPORT_ITEM_PLATE_ORDERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_REPORT_ITEM_PLATE_ORDERS_FAILURE')
                handleApiError(error, 'Pobranie zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReportItemPlates({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_REPORT_ITEM_PLATES_REQUEST')

        return axios
            .get(`/reports/report-item-plates${paginate}${query}`)
            .then(response => {
                commit('GET_REPORT_ITEM_PLATES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_REPORT_ITEM_PLATES_FAILURE')
                handleApiError(error, 'Pobranie zleceń oraz zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setQualitativeNotesFilters({ commit }, filters) {
        commit('SET_QUALITATIVE_NOTES_FILTERS', filters)
    },
    clearQualitativeNotesFilters({ commit }) {
        commit('CLEAR_QUALITATIVE_NOTES_FILTERS')
    },
    setReportItemPlateFilters({ commit }, filters) {
        commit('SET_REPORT_ITEM_PLATE_FILTERS', filters)
    },
    clearReportItemPlateFilters({ commit }) {
        commit('CLEAR_REPORT_ITEM_PLATE_FILTERS')
    },
    clearReportItemPlates({ commit }) {
        commit('CLEAR_REPORT_ITEM_PLATES')
    },
    clearReportItemPlateOrders({ commit }) {
        commit('CLEAR_REPORT_ITEM_PLATE_ORDERS')
    },
}